import * as yup from "yup";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

export const PATIENT_CHAT_MESSAGE_TYPES = {
  fromPatient: "message",
  fromProvider: "reply",
};

const requestSchema = yup.object({
  patientId: yup.number().required(),
});

const responseSchema = yup.array().of(
  yup.object({
    id: yup.number().required(),
    message: yup.string(),
    message_type: yup.string().required(),
    created: yup.string().required(),
    from_number: yup.string().required(),
    to_number: yup.string().required(),
    patient_id: yup.number().required(),
    user_id: yup.number().nullable(),
    user: yup
      .object({
        id: yup.number().required(),
        full_name: yup.string().required(),
        user_image_url: yup.string().nullable(),
      })
      .nullable(),
  }),
);

export const usePatientSmsQuery = (payload = {}, options = {}) => {
  const queryClient = useQueryClient();

  return useQuery(
    [QUERY_KEYS.patient.sms, payload.patientId],
    async () => {
      const req = requestSchema.validateSync(payload, { strict: true });
      const res = await http.get(HTTP_ENDPOINTS.patient.getSms(req.patientId));
      return responseSchema.validateSync(res?.data?.data, {
        strict: true,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patient.smsCount],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
};
